module.exports = __webpack_public_path__ + "img/consultoria.1312167a.jpeg";